import React, { useState,useEffect} from 'react';
import { Tabs, Card,SettingOutlined,ToolOutlined} from '../AntComponent';
import GeneralSetting from './settings-tab/GeneralSetting';
import ProjectConfigSetting from './settings-tab/ProjectConfigSetting';
export default function configurationSetting(){
    const items1 = [
        {
            key: "1",
            label: <><SettingOutlined/><span>General Setting</span></>,
            children: <GeneralSetting />
        },
        {
            key: "2",
            label: <><ToolOutlined/><span>Project Setting</span></>,
            children: <ProjectConfigSetting />
        },
      
    ]
    return (
         <div className='h-100'>
            <div className='mb-3'>
                <h5>Configuration Settings</h5>
            </div>
            <Card className="border-0 entitlement-cont h-100">
                <div className='stock-tabcontainers border-0'>
                    <Tabs defaultActiveKey='1' items={items1} />
                </div>
            </Card>
        </div>
    )
}